import React, { useState } from 'react';
import { SoftBackground } from '@/components/SoftBackground';
import { AdminLogin } from '@/components/admin/AdminLogin';
import { AdminDashboard } from '@/components/admin/AdminDashboard';

const TOKEN_KEY = 'indilabs_admin_token';
const USER_KEY = 'indilabs_admin_user';

export default function AdminPage() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [username, setUsername] = useState(() => localStorage.getItem(USER_KEY) || '');

  const handleLogin = (tok, user) => {
    localStorage.setItem(TOKEN_KEY, tok);
    if (user) localStorage.setItem(USER_KEY, user);
    setUsername(user || '');
    setToken(tok);
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setToken(null);
  };

  return (
    <div className="relative min-h-screen">
      <SoftBackground />
      {token ? (
        <AdminDashboard token={token} username={username} onLogout={handleLogout} />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
    </div>
  );
}
